const normalizePolicyNumber = (value) => {
  if (value === null || value === undefined) return "";
  return String(value).trim();
};

const getDuplicatePolicyNumberMap = (models = []) => {
  const seenByValue = new Map();
  const duplicates = new Set();

  (Array.isArray(models) ? models : []).forEach((model) => {
    const normalizedValue = normalizePolicyNumber(model?.policy_number);
    if (!normalizedValue) return;

    const ownerKey = model?.branch_category_id ?? model?.serviceId ?? `${Math.random()}`;
    const current = seenByValue.get(normalizedValue) || new Map();

    current.set(ownerKey, true);
    seenByValue.set(normalizedValue, current);
  });

  seenByValue.forEach((owners, value) => {
    if (owners.size > 1) {
      duplicates.add(value);
    }
  });

  return duplicates;
};

const isDuplicatePolicyNumber = (value, models = []) => {
  const normalizedValue = normalizePolicyNumber(value);
  if (!normalizedValue) return false;

  return getDuplicatePolicyNumberMap(models).has(normalizedValue);
};

const syncDuplicatePolicyNumberErrors = (models = []) => {
  const duplicates = getDuplicatePolicyNumberMap(models);

  (Array.isArray(models) ? models : []).forEach((model) => {
    if (!model) return;

    const normalizedValue = normalizePolicyNumber(model.policy_number);
    model.policy_numberHasError = Boolean(normalizedValue && duplicates.has(normalizedValue));
  });

  return duplicates;
};

module.exports = {
  normalizePolicyNumber,
  getDuplicatePolicyNumberMap,
  isDuplicatePolicyNumber,
  syncDuplicatePolicyNumberErrors,
};
